export const sentryConfig = (environment: string) => ({
  dsn: 'https://4a5309714058472280d1228ac62ecb3c@sentry.io/1405611',
  environment,
})
